import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import { Logo } from '../ui/Logo';
import { NavigationMenu } from '../ui/NavigationMenu';
import { CTAButton } from '../ui/CTAButton';

export const Header: React.FC = () => {
	const navigate = useNavigate();
	const [isScrolled, setIsScrolled] = React.useState(false);

	React.useEffect(() => {
		const handleScroll = () => {
			if (window.scrollY > 0) {
				setIsScrolled(true);
			} else {
				setIsScrolled(false);
			}
		};

		window.addEventListener('scroll', handleScroll);
		return () => {
			window.removeEventListener('scroll', handleScroll);
		};
	}, []);

	return (
		<header
			className={`fixed top-0 left-0 right-0 z-40 flex justify-center w-full px-4 transition-all duration-300 ${
				isScrolled ? 'bg-white shadow-md' : ''
			} py-2`}
		>
			<nav className='flex flex-col justify-center items-center px-8 py-4 w-full max-w-[1200px] bg-white/80 backdrop-blur-md shadow-lg rounded-full my-4 max-md:px-5 max-md:max-w-full'>
				<div className='flex flex-wrap gap-5 justify-between items-center w-full max-w-[1328px] max-md:max-w-full'>
					<div onClick={() => navigate('/')} className='cursor-pointer'>
						<Logo />
					</div>

					<div className='flex items-center gap-6 max-md:ml-auto'>
						<div className='hidden'>
							<CTAButton
								text='Start your journey'
								iconUrl='https://cdn.builder.io/api/v1/image/assets/17cfa75daf82417693353b2f7dd2694b/73e470795569c2eb651eef28f4dfe90186c31557d97eeb5d186b48d347751dd2?placeholderIfAbsent=true'
							/>
						</div>
						<NavigationMenu />
					</div>
				</div>
			</nav>
		</header>
	);
};

export default Header;
